function EnrolleeReport() {
    this.__type = "EnrolleeReport:www.veritracks.com";
    this.Version = 0;
    this.Id = -1;
    this.OrganizationId = -1;
    this.MetricId = -1;
    this.Value = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = EnrolleeReport;
}